import Vue from 'vue'
import App from './App.vue'
import VueCookies from 'vue-cookies'
import router from '../router/router'
import store from './store'
import global from '../public/js/global'
import iView from 'iview';
import 'iview/dist/styles/iview.css';
import echarts from 'echarts'

Vue.use(global)
Vue.use(iView)
Vue.use(VueCookies)

Vue.config.productionTip = false
Vue.prototype.$echarts = echarts
Vue.use(echarts)
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
